import type { AxiosRequestConfig } from 'axios'
import qs from 'qs'
import type { RequestOptions } from './types'
import { toFormData, toUrlencoded } from './utils'

/** 根据 contentType 组织 body 并设置 headers/paramsSerializer */
export function buildAxiosConfigFromOptions(options: RequestOptions): AxiosRequestConfig {
  const { url, method = 'GET', params, data, requestConfig, contentType = 'json' } = options

  if (!url) throw new Error('Missing url')

  const config: AxiosRequestConfig = {
    ...(requestConfig || {}),
    url,
    method,
    headers: {
      // 默认 Content-Type，稍后允许外部覆盖；formdata 会主动删除以让浏览器自动带 boundary
      'Content-Type':
        contentType === 'urlencoded' ? 'application/x-www-form-urlencoded' : 'application/json',
      ...(requestConfig?.headers || {}),
    },
  }

  if (method === 'GET' || method === 'HEAD') {
    config.params = params ?? requestConfig?.params
    // 数组无索引、跳过 null
    config.paramsSerializer = (d) => qs.stringify(d, { indices: false, skipNulls: true })
  } else {
    // 优先 data，回退 params（兼容旧思路）
    const body = data ?? params ?? requestConfig?.data
    if (contentType === 'formdata') {
      // FormData 让浏览器自动带 boundary，需移除手动设置的 Content-Type
      if (config.headers) delete (config.headers as any)['Content-Type']
      config.data = body instanceof FormData ? body : toFormData(body as any)
    } else if (contentType === 'urlencoded') {
      config.data =
        body instanceof URLSearchParams ? body : toUrlencoded((body ?? {}) as Record<string, any>)
      config.headers = { ...config.headers, 'Content-Type': 'application/x-www-form-urlencoded' }
    } else {
      config.data = body
      config.headers = { ...config.headers, 'Content-Type': 'application/json' }
    }
  }

  if (typeof options.useAuth === 'boolean') {
    config.useAuth = options.useAuth
  }
  return config
}
